/**
 * Bootstrap and jQuery initialization module
 * Wrapper for bootstrap.js functionality
 */

// Import jQuery and Bootstrap
// Note: These should be loaded via CDN or bundled with webpack

// Bootstrap initialization
const initializeBootstrap = () => {
    // Bootstrap tooltip initialization
    const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    if (tooltipTriggerList.length > 0 && typeof bootstrap !== 'undefined') {
        tooltipTriggerList.map(function (tooltipTriggerEl) {
            return new bootstrap.Tooltip(tooltipTriggerEl);
        });
    }

    // Bootstrap popover initialization
    const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
    if (popoverTriggerList.length > 0 && typeof bootstrap !== 'undefined') {
        popoverTriggerList.map(function (popoverTriggerEl) {
            return new bootstrap.Popover(popoverTriggerEl);
        });
    }
};

// Modal helpers
const ModalHelper = {
    showModal(modalId) {
        const modal = document.getElementById(modalId);
        if (modal && typeof bootstrap !== 'undefined') {
            const bsModal = new bootstrap.Modal(modal);
            bsModal.show();
        }
    },

    hideModal(modalId) {
        const modal = document.getElementById(modalId);
        if (modal && typeof bootstrap !== 'undefined') {
            const bsModal = bootstrap.Modal.getInstance(modal);
            if (bsModal) {
                bsModal.hide();
            }
        }
    }
};

// Collapse functionality
const CollapseHelper = {
    toggle(id) {
        const element = document.getElementById(id);
        if (element && typeof bootstrap !== 'undefined') {
            const bsCollapse = new bootstrap.Collapse(element);
            bsCollapse.toggle();
        }
    }
};

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', () => {
    initializeBootstrap();

    // Global Bootstrap helpers
    window.BootstrapHelper = {
        Modal: ModalHelper,
        Collapse: CollapseHelper
    };
});

export { ModalHelper, CollapseHelper };
